import { gql } from '@apollo/client';

const CLINIC_TICKET_COUNT = gql`
  query clinicTicketCount($filter: ClinicTicketsFilterInput) {
    clinicTicketCount(filter: $filter)
  }
`;

export default CLINIC_TICKET_COUNT;
